module.exports = __webpack_public_path__ + "media/completion.ab96ecb5.mp3";